import { Directive, ElementRef, Renderer } from '@angular/core';
import { AppState } from '../../config/state';

/**
 * Generated class for the CoHeaderDirective directive.
 *
 * See https://angular.io/api/core/Directive for more info on Angular
 * Directives.
 */
@Directive({
  selector: '[co-header]' // Attribute selector
})
export class CoHeaderDirective {
  constructor(private state:AppState, private renderer:Renderer, el:ElementRef) {
    if(this.state.mode==='desktop'){
      this.renderer.setElementStyle(el.nativeElement, 'display', 'none');
    }
  }
}



// WEBPACK FOOTER //
// ./src/directives/co-header/co-header.ts